import { useMyStorageRequests } from 'features/storage/queries';

/**
 * Design pass (spec §4.0, decision D-4.2) — the "Guardado" nav badge: how many of the client's storage
 * requests are published (waiting for the client to pick a quote). Same shape as
 * useShipmentQuotingCount/useDraftCount for the layout. Unlike useDraftCount, it reuses the storage
 * feature's own `useMyStorageRequests` on purpose (no new endpoint, no second query): the badge and
 * the Guardado list share one cache entry (`storageKeys.list()`), so publishing or paying a request
 * refreshes both. `null` while loading or when the list cannot be loaded (no badge then).
 */
const useStoragePublishedCount = ({ enabled = true }: { enabled?: boolean } = {}) => {
  // NEX-1645 (plan 2026-10-20, Tarea 3.3) — with the storage module `off` the layout passes `enabled: false`:
  // GET /storage/requests/mine is not called and there is no count.
  const query = useMyStorageRequests({ enabled });
  const count = query.data ? query.data.filter((request) => request.status === 'published').length : null;
  return { count, loading: query.isLoading };
};

export default useStoragePublishedCount;
